import Immutable from 'seamless-immutable';
import { PRINTERS_TYPES } from './actions';
import { createReducer } from '../../libs/saga-utils';

const DEFAULT_STATE = {
  printers: [],
  loading: false,
  printersDays: {}
};

const ACTIONS = {
  [PRINTERS_TYPES.LOAD_PRINTERS]: loadPrinters,
  [PRINTERS_TYPES.LOAD_PRINTERS_SUCCESS]: loadPrintersSuccess,
  [PRINTERS_TYPES.LOAD_PRINTERS_FAILURE]: loadPrintersFailure,
  [PRINTERS_TYPES.SET_PRINTER_FOR_DAY]: setPrinter
};

function loadPrinters(state) {
  return state.merge({
    loading: true
  });
}

function loadPrintersSuccess(state, { payload }) {
  const { printers } = payload;

  return state.merge({
    printers,
    loading: false
  });
}

function loadPrintersFailure(state) {
  return state.merge({
    loading: false
  });
}

function setPrinter(state, { payload }) {
  const { periodId, day, printerName } = payload;

  let printersDays = { ...state.printersDays };

  if (printersDays[periodId]) {
    const newDays = { ...printersDays[periodId] };
    newDays[day] = printerName;
    printersDays[periodId] = newDays;
  } else {
    printersDays[periodId] = {};
    printersDays[periodId][day] = printerName;
  }

  return state.merge({
    printersDays
  });
}

const printersReducer = createReducer(Immutable(DEFAULT_STATE), ACTIONS);

export default printersReducer;
